import { TextFieldProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export const FlexibleSelectTextField: React.FC<TextFieldProps> = (
  props: TextFieldProps,
): React.ReactElement => {
  const { name, label, value, error, helperText, disabled, children, onChange } = props;

  return (
    <TextField
      name={name}
      sx={styles.select}
      label={label}
      select={true}
      value={value}
      fullWidth={true}
      error={error}
      helperText={helperText}
      disabled={disabled}
      onChange={onChange}>
      {children}
    </TextField>
  );
};

const styles: Record<string, SystemStyleObject> = {
  select: {
    '& .MuiSelect-select.MuiSelect-outlined': {
      height: 'auto',
    },
  },
};
